/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MultiAccountConnectionsChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService#hasDataSharingConnectionAsDestination
 */
export const HAS_DATA_SHARING_CONNECTION_AS_DESTINATION_QUERY_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountConnectionsChirpService_hasDataSharingConnectionAsDestination';
export const HAS_DATA_SHARING_CONNECTION_AS_DESTINATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: HAS_DATA_SHARING_CONNECTION_AS_DESTINATION_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.hasDataSharingConnectionAsDestinationRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService#getDataSharingSourceAccounts
 */
export const GET_DATA_SHARING_SOURCE_ACCOUNTS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountConnectionsChirpService_getDataSharingSourceAccounts';
export const GET_DATA_SHARING_SOURCE_ACCOUNTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DATA_SHARING_SOURCE_ACCOUNTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getDataSharingSourceAccountsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService#hasCopyAssetConnectionAsSource
 */
export const HAS_COPY_ASSET_CONNECTION_AS_SOURCE_QUERY_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountConnectionsChirpService_hasCopyAssetConnectionAsSource';
export const HAS_COPY_ASSET_CONNECTION_AS_SOURCE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: HAS_COPY_ASSET_CONNECTION_AS_SOURCE_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.hasCopyAssetConnectionAsSourceRpc, {
      timeout: ctx.timeout
    });
  }
});